export default "__VITE_ASSET__BBk2mzr5__"